import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import LinkUserLoginForm from '../../containers/Login/LinkUserLoginForm';
import { patientLinkUserLoginRequest } from '../../redux/modules/auth/auth-middleware';
import Message from '../../containers/Message/Message';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { retrieveMessage } from '../../redux/modules/system-shared/message-bar-action-creator';


class LinkUserLoginPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      singleSignOnId: null,
      patientId: null,
    };
  }

  UNSAFE_componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(retrieveMessage());
    dispatch(setIsDedicatedWorkflow(false));
  }

  componentDidMount() {
    const { location } = this.props;
    const queryString = location.search;
    const dataIndex = queryString.indexOf('&data=');
    const patientIdIndex = queryString.indexOf('patientid=');

    const singleSignOnId = queryString.substring(dataIndex + 6);
    const patientId = parseInt(queryString.substring(patientIdIndex + 10, dataIndex), 10);

    this.setState({
      singleSignOnId,
      patientId,
    });
  }

  handleLogin = (creds) => {
    this.props.dispatch(patientLinkUserLoginRequest({ ...creds,
      data: this.state.singleSignOnId,
      type: 'patientLinkUser' }, this.state.patientId));
  };

  render() {
    return (
      <div className="col">
        <Message />
          <LinkUserLoginForm handleLogin={this.handleLogin} />
      </div>
    );
  }
}

LinkUserLoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
});

export default connect(mapStateToProps)(LinkUserLoginPage);